import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './home.component';
import {AboutComponent} from './about.component';
import {ContactComponent} from './contact.component';

//import { ComponentsModule } from '../components/components.module';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        RouterModule
        //ComponentsModule
    ],
    declarations: [ 
        HomeComponent, 
        AboutComponent,
        ContactComponent
         ],
    exports:[ 
        HomeComponent ,
        AboutComponent,
        ContactComponent
    ],
    providers: []
})
export class HomeModule { }



// WEBPACK FOOTER //
// /apps/dev/flashqubes/src/app/home/home.module.ts